module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-zip-f3191353.svg";